import { createSlice } from '@reduxjs/toolkit';
import { ThunkDispatch as Dispatch } from 'redux-thunk';
import { getPaymentTypeList } from '../../../services/api-ssrr/CollectionManagerAPIClient';
import { UserState } from '../../../types-interfaces/interfaces';
import { concatValue } from '../../../functions/Data';

const initialState = {
    loading: false,
    paymentTypes: [{ value: 1, name: ''}],
    error: {}
}

export const PaymentTypeSlice = createSlice({
    name: 'paymentType',
    initialState,
    reducers: {
        init: (state) => {
            state.loading = true
        },
        paymentTypes: (state, { payload }) => {
            state.loading = false
            state.paymentTypes = payload
        },
        failure: (state, { payload }) => {
            state.error = payload
        }
    }
});

export const { init, paymentTypes, failure } = PaymentTypeSlice.actions;
export const selectPaymentTypes = (state: any) => state.paymentType;
export default PaymentTypeSlice.reducer;

export function fetchPaymentTypes(userState: UserState, addZeroValue: boolean) {
    return async (dispatch: Dispatch<any, any, any>) => {
        try {
            dispatch(init());
            const response = await getPaymentTypeList(userState.currentSession?.accessToken!, userState.currentSession?.user?.email!);
            
            response.items.sort((a, b) => a.value - b.value);

            const newResponse = response.items.map((item) => {
                return {...item, value: concatValue(item.value, item.toku)};
            });
            
            if (addZeroValue){
                newResponse.unshift({ name: "Todos", value: "0" });
            }

            dispatch(paymentTypes(newResponse));
        } catch (error) {
            dispatch(failure({ message: 'Error' }))
        }
    }
}